import type { BoardType } from '@/shared/constants/app/routes.constant.ts';
import type { BoardListParams } from '../types/board.type.ts';

/**
 * Board 도메인 Query Key 팩토리.
 *
 * 계층 구조:
 *  all                 → ['board']
 *  board(type)         → ['board', 'notices']
 *  lists(type)         → ['board', 'notices', 'list']
 *  list(type, params)  → ['board', 'notices', 'list', { page, size, ... }]
 *  details(type)       → ['board', 'notices', 'detail']
 *  detail(type, id)    → ['board', 'notices', 'detail', '17']
 *
 * 무효화 패턴:
 *  invalidateQueries({ queryKey: boardKeys.lists(type) })  → 해당 게시판 목록 전체
 *  invalidateQueries({ queryKey: boardKeys.detail(type, id) }) → 특정 글
 *  생성/삭제 후엔 lists, 수정 후엔 lists + detail 무효화.
 */
export const boardKeys = {
  all: ['board'] as const,
  board: (type: BoardType) => [...boardKeys.all, type] as const,
  lists: (type: BoardType) => [...boardKeys.board(type), 'list'] as const,
  list: (type: BoardType, params: BoardListParams) =>
    [...boardKeys.lists(type), params] as const,
  details: (type: BoardType) => [...boardKeys.board(type), 'detail'] as const,
  detail: (type: BoardType, id: string | number) =>
    [...boardKeys.details(type), String(id)] as const,
};
